import { render } from "./BaseMessage.vue?vue&type=template&id=34c734e1&scoped=true"
const script = {}

import "./BaseMessage.vue?vue&type=style&index=0&id=34c734e1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c734e1"]])

export default __exports__